import { Flex, Typography } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

// Shared by the map overlay (capped height) and the area list (height matches the map, min floor).
export const CLEANING_AREA_SELECTION_MAX_HEIGHT = 336;
export const CLEANING_AREA_LIST_MIN_HEIGHT = 175;

export const CleaningZonesContainer = styled(Flex)`
  ${(): FlattenSimpleInterpolation => css`
    width: 100%;
  `}
`;

export const CleaningZonesAreaSelectionRow = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    width: 100%;
    gap: ${kcc.spacing.SM};
    align-items: stretch;
  `}
`;

export const CleaningZonesErrorText = styled(Typography.Text)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    &.ant-typography {
      color: ${kcc.colors.ERROR};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    }
  `}
`;

export const CleaningZonesHowToIcon = styled(SvgIcon)`
  &.svg-icon {
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;
